import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { formatEncodingExceptionqalxwmlsg11w as formatEncodingException } from './internal/JsonExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecodingExceptionClass;
function JsonDecodingException() {
  if (JsonDecodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(fullMessage, shortMessage, offset, path, input, hint, cause) {
        return new.target.i2s(fullMessage, shortMessage, offset, path, input, hint, cause);
      }
      static i2s(fullMessage, shortMessage, offset, path, input, hint, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.s2s(fullMessage, cause);
        captureStack($this, $this.h2s_1);
        $this.c2s_1 = shortMessage;
        $this.d2s_1 = offset;
        $this.e2s_1 = path;
        $this.f2s_1 = input;
        $this.g2s_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDecodingException');
    JsonDecodingExceptionClass = $;
  }
  return JsonDecodingExceptionClass;
}
var JsonExceptionClass;
function JsonException() {
  if (JsonExceptionClass === VOID) {
    class $ extends SerializationException() {
      static s2s(message, cause) {
        var $this = this.z1o(message, cause);
        captureStack($this, $this.r2s_1);
        $this.q2s_1 = message;
        delete $this.message;
        return $this;
      }
      r() {
        return this.q2s_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'JsonException');
    JsonExceptionClass = $;
  }
  return JsonExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(shortMessage, classSerialName, hint, cause) {
        return new.target.d2t(shortMessage, classSerialName, hint, cause);
      }
      static d2t(shortMessage, classSerialName, hint, cause) {
        classSerialName = classSerialName === VOID ? null : classSerialName;
        hint = hint === VOID ? null : hint;
        cause = cause === VOID ? null : cause;
        var $this = this.s2s(formatEncodingException(shortMessage, hint), cause);
        captureStack($this, $this.c2t_1);
        $this.z2s_1 = shortMessage;
        $this.a2t_1 = classSerialName;
        $this.b2t_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
//region block: exports
export {
  JsonDecodingException as JsonDecodingExceptionoyag1psadwuw,
  JsonEncodingException as JsonEncodingException3vzv9k0f9l05u,
};
//endregion

//# sourceMappingURL=JsonExceptions.mjs.map
